import { useMemo, useRef } from 'react';

// eslint-disable-next-line
export const useStableObject = (obj: any) => {
  const stringifiedObj = JSON.stringify(obj);
  const stableObj = useRef(obj);

  return useMemo(() => {
    const currentStringified = JSON.stringify(obj);

    if (currentStringified === stringifiedObj) {
      return stableObj.current;
    }

    stableObj.current = obj;

    return obj;
  }, [obj, stringifiedObj]);
};
